import pb from '../lib/pocketbase';
import { toasts } from 'svelte-toasts';

// Fetch report data grouped by tipo
export async function fetchActivoReportData() {
  try {
    // Get all activos with their tipo expanded
    const activos = await pb.collection('activo').getFullList({
      expand: 'tipo',
      $autoCancel: false
    });

    // Group by tipo
    const groupedData = {};
    
    for (const activo of activos) {
      const tipoId = activo.tipo;
      const tipoDescrip = activo.expand?.tipo?.descrip || 'Sin Tipo';
      const precio = activo.precio || 0;

      // Initialize tipo group if not exists
      if (!groupedData[tipoId]) {
        groupedData[tipoId] = {
          tipoId,
          tipoDescrip,
          totalPrecio: 0,
          activos: []
        };
      }

      // Add activo to tipo group
      groupedData[tipoId].activos.push({
        id: activo.id,
        codigo: activo.codigo || 'Sin Código',
        nombre: activo.nombre || 'Sin Nombre',
        descripcion: activo.descrip || 'Sin Descripción',
        precio: precio,
        estado: activo.sta ? 'Activo' : 'Inactivo',
        fechaCreacion: activo.created
      });

      // Add precio to tipo total
      groupedData[tipoId].totalPrecio += precio;
    }

    // Convert to array format for display
    const reportData = Object.values(groupedData).map(tipo => ({
      ...tipo,
      activosCount: tipo.activos.length
    }));

    // Calculate total sum
    const totalSum = reportData.reduce((sum, tipo) => sum + tipo.totalPrecio, 0);

    return {
      reportData,
      totalSum
    };

  } catch (error) {
    console.error('Error fetching activo report data:', error);
    toasts.error('Error al cargar los datos del reporte');
    throw error;
  }
}

// Export report data to CSV
export function exportActivoReportToCSV(reportData) {
  let csv = 'Tipo,Codigo,Nombre,Descripcion,Precio,Estado,Fecha Creacion\n';
  
  for (const tipo of reportData) {
    for (const activo of tipo.activos) {
      csv += `"${tipo.tipoDescrip}","${activo.codigo}","${activo.nombre}","${activo.descripcion}",${activo.precio},"${activo.estado}","${activo.fechaCreacion}"\n`;
    }
  }
  
  return csv;
}

// Download CSV file
export function downloadCSV(csvContent, filename = 'reporte_activo_precio.csv') {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

// Fetch filter options for tipos
export async function fetchFilterOptions() {
  try {
    // Fetch tipos
    const tiposResponse = await pb.collection('tipo').getFullList({
      sort: 'descrip',
      $autoCancel: false
    });
    
    const tipos = tiposResponse.map(tipo => ({
      value: tipo.id,
      label: tipo.descrip
    }));

    return {
      tipos
    };

  } catch (error) {
    console.error('Error fetching filter options:', error);
    toasts.error('Error al cargar las opciones de filtro');
    return {
      tipos: []
    };
  }
}
